import React from 'react';
import { Organization, User } from '../../../../types';
import { App } from '../App/App';

interface Props {
  user: User | null;
  org: Organization | null;
}

export const EmailQ: React.FC<Props> = ({ user, org }): JSX.Element => {
  const emailAnalyzerApp = user?.apps?.find(
    (el) => el.name === 'email-analyzer'
  );
  const isActive = emailAnalyzerApp?.active;

  const serviceName = emailAnalyzerApp?.name;

  const xRayActive = org?.enabledFeatures?.includes(
    'xRayAnalysis' || 'xRaySimulation'
  );

  const evNotifiicationActive = org?.enabledFeatures?.includes(
    'eventNotifications'
  );

  const clusterEngagementActive = org?.enabledFeatures?.includes(
    'watchContacts'
  );

  const enabledFeatures = {
    xRay: xRayActive || false,
    eventNotifications: evNotifiicationActive || false,
    clusterEngagements: clusterEngagementActive || false,
  };

  return (
    <App
      defaultActive={isActive}
      title="Q for Chrome"
      text="Analyze your email communication with prospects and learn how to maximize your advantage."
      name={serviceName}
      role={user?.role}
      isQChrome
      enabledFeatures={enabledFeatures}
    />
  );
};
